import { QueryClient } from '@tanstack/react-query';

/**
 * The one TanStack Query client (ADR-026, Decision F2). Never holds a
 * secret - only server-state shaped data (Guardian relationships, student
 * records, etc.) is cached here.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});
